import validate from "/app/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@20.19.23_@vue+compiler-sfc@3.5.29_db0@0.3_d57241d6da81c9f7a2819d13c1af0dcb/node_modules/nuxt/dist/pages/runtime/validate.js";
import logger_45global from "/app/middleware/logger.global.ts";
import route_45global from "/app/middleware/route.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@20.19.23_@vue+compiler-sfc@3.5.29_db0@0.3_d57241d6da81c9f7a2819d13c1af0dcb/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  logger_45global,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}